import { Box, Typography } from "@mui/material";
import React, { useState } from "react";
import AddGroupIcon from "../assets/SVG/addGroupIcon";
import addGroupPicError from "../assets/image/groupImageError.png";
import CreateGroupPop from "../components/createGroupPop";
import { useRef } from "react";
import CardGroup from "../components/cardGroup";

import ViewInfo from "../components/viewInfo";
import { useEffect } from "react";
import {
  getAllGroups,
  getGroupAdminInfo,
  getGroupInfo,
  getGroups,
} from "../api/group";

export default function Dashboard() {
  const [openPopover, setOpenPopover] = useState();
  const refBox = useRef();
  const [mode, setMode] = useState("create");
  const [groupId, setGroupId] = useState();

  const [data, setData] = useState();
  const [dataView, setDataView] = useState();
  const [dataAdminInfo, setDataAdminInfo] = useState();
  const [dataGroup, setDataGroup] = useState();
  const handleClickCardGroup = (id) => {
    getGroupInfo(id)
      .then((x) => setDataView(x))
      .catch((z) => console.log(z));
    setMode("view");
    // getGroupAdminInfo(id)
    //   .then((x) => setDataAdminInfo(x))
    //   .catch((z) => console.log(z));
  };
  useEffect(() => {
    getAllGroups()
      .then((x) => setData(x))
      .catch((z) => console.log(z));
  }, []);
  console.log(data);
  return (
    <>
      {mode === "create" && (
        <>
          {/* <CreateGroupPop
            openPopover={openPopover}
            setOpenPopover={setOpenPopover}
          /> */}
          {/* <Box
            ref={refBox}
            mt="3%"
            display="flex"
            width="fit-content"
            alignItems="center"
            onClick={() => setOpenPopover(refBox.current)}
            sx={{ cursor: "pointer" }}
          >
            <AddGroupIcon />
            <Typography color="#4C8395" fontSize="16px" mr="10px">
              {"دسترسی گروه‌ها"}
            </Typography>
          </Box> */}
          <Typography mt="30px" className="title_GroupOnline">
            {"گروه های فعال"}
          </Typography>
          <Box display="flex" flexWrap={"wrap"} gap="10px">
            {data?.length > 0 &&
              data.map((item) => (
                <>
                  {item.isActive === true && (
                    <CardGroup
                      {...item}
                      onClick={() => {
                        handleClickCardGroup(item.id);
                        setGroupId(item.id);
                        setDataGroup(item);
                      }}
                    />
                  )}
                </>
              ))}
          </Box>
          {data?.length <= 0 && (
            <Box textAlign="center">
              <img src={addGroupPicError} style={{ marginTop: "0px" }} />
              <Typography mt="00px">{"گروه جهادی یافت نشد!"}</Typography>
            </Box>
          )}
        </>
      )}
      {mode === "view" && (
        <ViewInfo
          setMode={setMode}
          id={groupId}
          data={dataView}
          dataAdmin={dataAdminInfo}
          dataGroup={dataGroup}
        />
      )}
    </>
  );
}
